export const SALESBANNER_CURRENT_SLIDE_CHANGED = 'SALESBANNER_CURRENT_SLIDE_CHANGED';

// eslint-disable-next-line max-len
export const salesBannerSlideChangedCreator = (salesBannerSliceId, slideIndex) => ({
  type: SALESBANNER_CURRENT_SLIDE_CHANGED,
  payload: {
    salesBannerSliceId,
    slideIndex,
  },
});
